function doesTitleStartWithHowTo (titleText) {
  return titleText.toLowerCase().startsWith('how to');
}

export default doesTitleStartWithHowTo;
